// extracted by mini-css-extract-plugin
export default {"ratesTable":"ghGGyhKqTjMvDCkI","ratesH":"a4QiaDUUqSUhls2d","rateCol":"n1uQLrGrlMaV4XRg","seasonLabel":"RMb2b0OYUu0g023v"};